module.exports = __webpack_public_path__ + "img/image27.c2283ed2.png";